import { render, staticRenderFns } from "./BasicDialog.vue?vue&type=template&id=f8b2bd16&scoped=true"
import script from "./BasicDialog.vue?vue&type=script&lang=js"
export * from "./BasicDialog.vue?vue&type=script&lang=js"
import style0 from "./BasicDialog.vue?vue&type=style&index=0&id=f8b2bd16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b2bd16",
  null
  
)

export default component.exports